<div style="padding: 10px 20px;">
  <span class="info-color" *ngIf="isLogging" i18n="@@MSG_SystemLoginLogging">
    登入中...
  </span>
  <span class="error-color" *ngIf="isLoginFailed" i18n="@@MSG_SystemLoginDirectlyFailed">登入失敗.</span>  
</div>
